import type { TourConfig } from '../../types/tour.types'

// Bulk Downloads (Purchase History). The page header carries a `data-tour` anchor added
// alongside this tour; the table and pagination footer target stable classes rendered by
// BulkDownloadsTable.
const bulkDownloadsTour: TourConfig = {
  id: 'bulk-downloads',
  title: 'Get back to any export in seconds',
  module: 'Purchase History',
  routeName: 'BulkDownloads',
  order: 14,
  autoStart: true,
  steps: [
    {
      id: 'intro',
      title: 'Your export history, ready to re-open',
      body: 'Every **bulk export** you run lands here as its own job — the list you downloaded, the leads and contacts it produced, and a link straight back to the file. No more hunting for a CSV you saved weeks ago.',
    },
    {
      id: 'header',
      target: '[data-tour="bd-header"]',
      placement: 'bottom',
      title: 'All your export jobs',
      body: 'This is the running log of your **bulk downloads**. Use the date filter above the table to jump to the batch you need.',
    },
    {
      id: 'table',
      target: '.bd-list__table',
      placement: 'top',
      title: 'What each export delivered',
      body: 'Every row shows the export **date**, **name**, and how many **leads** and **contacts** it contained. Click **View** to re-open the full download and grab the data again.',
    },
    {
      id: 'pagination',
      target: '.bd-pagination',
      placement: 'top',
      title: 'Browse your full history',
      body: 'Older exports are a page away. Change the **page size** or jump to a specific page to find a download from further back.',
    },
  ],
}

export default bulkDownloadsTour
